import request from './request';

export function createPoll(poll) {
    return request('post', `/apiv2/polls/create`, poll);
}

export function updatePoll(id, poll) {
    return request('put', `/apiv2/polls/${id}/update`, poll);
}

export function deletePoll(id) {
    return request('delete', `/apiv2/polls/${id}/delete`);
}

export function pause(id) {
    return request('post', `/apiv2/polls/${id}/pause`);
}

export function relaunch(id) {
    return request('post', `/apiv2/polls/${id}/relaunch`);
}

//Show in modal of votes
export function votes(id, option, params) {
    return request('get', `/apiv2/polls/${id}/votes/${option}`, params);
}

export function vote(id, params) {
    return request('post', `/apiv2/polls/${id}/vote`, params);
}

export function fetch(params) {
    return request('get', `/apiv2/polls/list`, params);
}
